import { render, staticRenderFns } from "./header-back.vue?vue&type=template&id=3bc75b58&scoped=true&"
import script from "./header-back.vue?vue&type=script&lang=js&"
export * from "./header-back.vue?vue&type=script&lang=js&"
import style0 from "./header-back.vue?vue&type=style&index=0&id=3bc75b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc75b58",
  null
  
)

export default component.exports